import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import ActivityBar from "../Reusable/ActivityBar/ActivityBar";
import SectionSlider from "../Reusable/SectionSlider/SectionSlider";
import { sections, sectionPaths } from "../../constants/sectionData";
import GlobalPoliciesFileViewPopup from "../Reusable/Popup/GlobalPoliciesFileViewPopup";
import FileSection from "../Reusable/RiskSecurity/FileSelection";
import RiskManagementTool from "../GlobalPolicies/RiskManagementToolUpload";
import RiskManagementToolUpload from "../GlobalPolicies/RiskManagementToolUpload";
import GPAdminFileViewPopup from "../Reusable/Popup/GPAdminFileViewPopup";
import FileSection2 from "../Reusable/RiskSecurity/FileSelection2";

interface RisksSecurityProps {
  isManager?: boolean;
  isAdmin?: boolean;

}

const RisksSecurity: React.FC<RisksSecurityProps> = ({ isManager, isAdmin }) => {
  const management = localStorage.getItem("management") || "Default Location Name";
  console.log('Risk management', management);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedFileData, setSelectedFileData] = useState<any>(null);
  const [selectedSectionName, setSelectedSectionName] = useState<string>("");

   

  const handleClosePopup = () => {
    setPopupOpen(false);
  };

  const handleFileUploadSuccess = () => {
    // Handle any logic after successful file upload
    console.log("File uploaded successfully");
  };

  // const handleViewClick = (fileData: any, sectionName: string) => {
  //   setSelectedFileData(fileData); // Set the file data for the popup
  //   setSelectedSectionName(sectionName); // Set the section name for the popup
  //   setPopupOpen(true); // Open the popup
  // };

  // In RisksSecurity component
const handleViewClick = ({ fileData, sectionName, refresh }: { 
  fileData: any, 
  sectionName: string,
  refresh: () => void 
}) => {
  setSelectedFileData({ ...fileData, refresh }); // Store refresh with file data
  setSelectedSectionName(sectionName);
  setPopupOpen(true);
};

  const breadcrumbs = [
    <Link key="1" color="#000" to="/">
         Home
       </Link>,
       <Link key="2" color="#000" to="/operations/management">
         Evidence Upload
       </Link>,
       <Link key="3" color="#000" to="/operations/management">
         Management
       </Link>,
    <Typography key="4">{management}</Typography>,
  ];

  return (
    <>
      <ActivityBar breadcrumbs={breadcrumbs} />
      <SectionSlider
        sections={sections}
        sectionPaths={sectionPaths}
        highlightSection={"Risks and Security"}
        highlightColor="#D7A833"
        defaultColor="#666"
      />

      <Typography variant="h6" sx={{ fontWeight: '600', paddingLeft: '40px', fontSize: '16px' }}>Risks and Security</Typography>
      <Typography sx={{ color: '#000', fontSize: '16px', padding:'10px 40px',pt:'5px' }}>
       Question : BSC has identified which of its processes fall under the Business Continuity Process (BCP) and has a BCP plan in place to support disaster recovery
        </Typography>
    

      <Box className="titlecardrisk" sx={{ display: "flex", gap: "10px", padding: "24px", paddingLeft: "40px", }}>
        <FileSection
          key="section1"
          sectionName="GBS Process under BCP"
          fileTitle="Provide documentation or reports that identify which GBS processes are critical and must be included in the Business Continuity Plan (BCP)."
          management={management}
          apiPath="/management/filter_risk_security"
          apiPathUpload="/management/risk_security"
          isManager={isManager}
          onFileUploadSuccess={handleFileUploadSuccess}
          onViewClick={({ fileData, sectionName, refresh }) => {
            setSelectedFileData({ ...fileData, refresh });
            setSelectedSectionName(sectionName);
            setPopupOpen(true);
          }}
        />

    
      </Box>

      {isManager && (
        <RiskManagementToolUpload isManager={true} />

      )}

      {isAdmin && (
        <RiskManagementToolUpload isAdmin={true} />
      )}



      {/* File View Popup */}
      {isPopupOpen && isManager && selectedFileData && (
        <GlobalPoliciesFileViewPopup
          onClose={handleClosePopup}
          open={true}
          name={selectedFileData.file_name}
          id={selectedFileData.id}
          functionl1={selectedFileData.function_l1}
          date={selectedFileData.updated_at}
          updatedBy={selectedFileData.updated_by}
          sectionTitle={selectedSectionName} // Dynamic section title
          userDetail={true}
          apiPath={`/management/risk_security/${selectedFileData.id}`}
        />
      )}

      {isPopupOpen && isAdmin && selectedFileData && (
        <GPAdminFileViewPopup
          onClose={handleClosePopup}
          open={true}
          name={selectedFileData.file_name}
          id={selectedFileData.id}
          status={selectedFileData.status}
          functionl1={selectedFileData.function_l1}
          date={selectedFileData.updated_at}
          updatedBy={selectedFileData.updated_by}
          sectionTitle={selectedSectionName} // Dynamic section title
          apiPath={`/management/risk_security/${selectedFileData.id}`} // Pass the API path for file details
          statusApiPath="/management/risk_security_status" // Pass the API path for status updates
          reason_to_approve={selectedFileData.reason_to_approve}
          reason_to_revert={selectedFileData.reason_to_revert}
          onSuccess={selectedFileData.refresh}

        />
      )}
    </>
  );
};

export default RisksSecurity;